import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NB_AUTH_OPTIONS } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';
import { ApiService } from '../../../services/api.service';
import { URLConfig } from '../../../../configs/url-config';

@Component({
  selector: 'nb-change-password-confirm',
  templateUrl: './change-password-confirm.component.html',
  styleUrls: ['./change-password-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbChangePasswordConfirmComponent implements OnInit {
  redirectDelay = 0;
  showMessages: any = {};
  strategy = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(
    private _apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    protected cd: ChangeDetectorRef,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
  ) {
    this.redirectDelay = this.getConfigValue('forms.resetPassword.redirectDelay');
    this.showMessages = this.getConfigValue('forms.resetPassword.showMessages');
    this.strategy = this.getConfigValue('forms.resetPassword.strategy');
  }

  ngOnInit(): void {
    const loggedInUser = this._apiService.getValueLocalstorage();
    const loggedInEmail = loggedInUser?.email || '';

    this.route.queryParams.subscribe((params) => {
      this.user.email = params?.email || loggedInEmail;
      this.cd.detectChanges();
    });
  }

  changePass(): void {
    this.errors = this.messages = [];
    this.submitted = true;

    const payload = {
      email: this.user.email,
      resetCode: this.user.resetCode,
      newPassword: this.user.newPassword,
    };

    this._apiService.postRequest(URLConfig.changepassword, payload).subscribe(
      () => {
        this._apiService.success('Password changed successfully.');
        this.router.navigate(['/pages/dashboard']);
        this.submitted = false;
        this.cd.detectChanges();
      },
      () => {
        this.submitted = false;
        this.cd.detectChanges();
      },
    );
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
